<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading" v-if="producer.id">
        {{ $t('producer.edit') }}
      </div>
      <div class="content-heading" v-else>
        {{ $t('producer.add') }}
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-producer">

                <div class="form-group">
                  <label for="name">{{ $t('producer.name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.name}"
                    autocomplete="off"
                    class="form-control"
                    id="name"
                    :placeholder="$t('producer.insert-name')"
                    type="text"
                    v-model="producer.name">
                  <ul class="parsley-errors-list filled" v-if="errors.name">
                    <li class="parsley-required">{{ errors.name[0] }}</li>
                  </ul>
                </div>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="producer.is_active"
                          :class="{'parsley-error': errors.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span> {{ $t('producer.active') }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6" v-if="!this.producer.id">
                    <more/>
                  </div>

                </div>
                <buttons url="producers"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import More from '@/components/More.vue'
import {parseApiError} from '@/utils'

const getData = (id, next) => {
  if (id) {
    Promise.all([api.get(`/producers/${id}/`)])
      .then(([producer]) => {
        next({
          producer: producer.data
        })
      })
  } else {
    next({
      producer: {
        name: '',
        is_active: true
      }
    })
  }
}

export default {
  components: {
    buttons: Buttons,
    more: More
  },
  data () {
    return {
      producer: {},
      more: null,
      errors: {}
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'producers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save () {
      this.errors = {}

      if (this.producer.id) {
        api.patch(`/producers/${this.producer.id}/`, this.producer)
          .then(() => {
            message.success(this.$i18n.t('producer.changed'))
            this.$router.push({name: 'producers'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/producers/', this.producer)
          .then(() => {
            message.success(this.$i18n.t('producer.added'))
            if (this.more) {
              this.producer.name = ''
              this.producer.is_active = true
              this.$router.push({name: 'producer_add'})
            } else {
              this.$router.push({name: 'producers'})
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Producer.vue